export default "__VITE_ASSET__5reyXsWN__"